<div class="surface-card p-4 shadow-2 border-round">
  <ng-template [ngIf]="isLoadingResults">
    <app-loading></app-loading>
</ng-template>
    <div class="mb-3 flex md:flex-row align-items-center md:justify-content-between justify-content-between ">
      <div class="flex justify-start md:justify-start">
        <span *ngIf="filterIsSet && filtroPratica" class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRONTOFIBRA DELLA PRATICA <b>{{filtroPratica}}</b></span>

        <span *ngIf="!filterIsSet"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRONTOFIBRA</span>
        <span *ngIf="filterIsSet && !filtroLotto && filtroStato"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRONTOFIBRA DEL <b>BANDO {{filtroBando}}</b> IN STATO <i>{{filtroStatoDecodificato}}</i></span>
        <span *ngIf="filterIsSet && filtroLotto && filtroStato"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRONTOFIBRA DEL <b>BANDO {{filtroBando}}</b> E LOTTO  <i>{{filtroLotto}}</i> IN STATO <i>{{filtroStatoDecodificato}}</i></span>
        <span *ngIf="filterIsSet && filtroBando && !filtroStato && !filtroLotto"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRONTOFIBRA DEL <b>BANDO {{filtroBando}}</b> <span *ngIf="filtroInLavorazione"><i> IN LAVORAZIONE</i></span></span>
        <span *ngIf="filterIsSet && filtroLotto && filtroBando && !filtroStato"  class="text-xl font-medium text-2000 font-['Poppins']" style="color: #0f1cab">PRONTOFIBRA DEL <b>BANDO {{filtroBando}}</b> E LOTTO <i>{{filtroLotto}}</i></span>
 
          
         
      </div>
      <div class="flex justify-end md:justify-center">
      </div>
       
      <div class="flex justify-end md:justify-end">
        <button *ngIf="!isPM && !this.isImpresa && !this.isDirigenteFirmaPacchetti"
        pButton type="button" icon="pi pi-cloud-upload"
        pTooltip="Aggiorna i prontofibra" tooltipPosition="bottom"
        class="font-['Poppins'] mr-3"
        style="background-color:#fffdea; color: #05542b; border-color: #05542b; font-size: 13px;"
        label="Carica file FIBERCOP"
        (click)="importaPF()" [disabled]="isLoadingResults || isDemo"
      >
    </button>
        <button *ngIf="!isPM"
        pButton type="button" icon="pi pi-cloud-download"
        pTooltip="Scarica export" tooltipPosition="bottom"
        class="font-['Poppins'] mr-3"
        style="background-color:#e3faf8; color: #3d64b3; border-color: #3d64b3; font-size: 13px;"
        label="Scarica report"
        (click)="scaricaReportProntofibra()" [disabled]="isLoadingResults"
      ></button>
    
    <button *ngIf="!isPM && !this.isImpresa && !this.isDirigenteFirmaPacchetti"
      pButton type="button" 
      pTooltip="Invia sollecito a FIBERCOP per tutte le pratiche in attesa" tooltipPosition="bottom"
      class="font-['Poppins'] mr-3"
      style="background-color:#e8c516; color: #000000; border-color: #62552a; font-size: 13px;"
      label="Sollecita IN ATTESA"
      (click)="sollecitaFibercop()" [disabled]="isLoadingResults || isDemo"
    >
    <span class="material-symbols-outlined" style="margin-right: 8px;">campaign</span>
    </button>
  
      </div>
    </div>
 
 <!--[sortField]="'numero'" [sortOrder]="1"-->
            <div fxFlex="95%" class="mt-2">
                <p-table #prontofibraDT styleClass="p-datatable-sm" [loading]="isLoadingResults" [value]="prontofibraFiltrati" dataKey="id" [(selection)]="selectedProntofibra"
                [selectionPageOnly]="true" [rowHover]="true" [rows]="50" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[50,100,200]" responsiveLayout="scroll" [paginator]="true"
                currentPageReportTemplate="{first} - {last} di {totalRecords}" [filterDelay]="0"
                [globalFilterFields]="['cui','bando','categoriaKO','tipoSede','tipoSedeEffettiva','denominazione','regione','comune','codiceMiur','azienda', 'lotto','numeroOda','statoFlowdyFase1','codiceStatoInfratelFase1']"
                >
                <ng-template pTemplate="caption">
                  <div class="flex align-items-center md:justify-content-between justify-content-between custom-header-bg">
                  
                    <div class="flex justify-start md:justify-start" style="align-items: stretch;">
                      <span class="p-input-icon-left mr-2">
                        <i class="pi pi-search"></i>
                        <input type="text" pInputText placeholder="Cerca" (input)="filtraProntofibra($event)" [disabled]="isLoadingResults" style="height: 2.5rem;" />
                      </span>
                      <p-multiSelect 
                        *ngIf="!filterIsSet && !isImpresa"
                        styleClass="fieldFilterControl" 
                        [options]="imprese"
                        [showToggleAll]="false"
                        optionLabel="ragioneSociale"
                        optionValue="id"
                        (onChange)="filtraProntofibra($event)"
                        placeholder="Impresa"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroprontofibra.impresa"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniTipoProntofibra"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraProntofibra($event)"
                        placeholder="Tipo sede"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroprontofibra.tipo"
                      />
                     
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniStatoPF"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraProntofibra($event)"
                        placeholder="Stato PF"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroprontofibra.statoProntofibra"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet && !isImpresa"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="categorieVincolo"
                        [showToggleAll]="false"
                        [optionLabel]="label"
                        optionValue="codice"
                        (onChange)="filtraProntofibra($event)"
                        placeholder="Categoria KO"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroprontofibra.categoriaAttesa"
                      />
                     <!--  <p-multiSelect 
                      *ngIf="!filterIsSet"
                      styleClass="ml-2 fieldFilterControl" 
                      [options]="listeService.categorieKOPF"
                      [showToggleAll]="false"
                      optionLabel="label"
                      optionValue="label"
                      (onChange)="filtraProntofibra($event)"
                      placeholder="Cause KO"
                      [showClear]="false"
                      [filter]="false"
                      [showHeader]="false"
                      [(ngModel)]="filtroprontofibra.categoriaAttesa"
                    /> -->
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniStatoInfratelFase1"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraProntofibra($event)"
                        placeholder="Stato fase 1"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroprontofibra.statoFase1"
                      />
                      <!-- <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniBando"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraProntofibra($event)"
                        placeholder="Bando"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroprontofibra.bando"
                      />
                      <p-multiSelect 
                        *ngIf="!filterIsSet"
                        styleClass="ml-2 fieldFilterControl" 
                        [options]="listeService.opzioniRegioneProntofibra"
                        [showToggleAll]="false"
                        optionLabel="label"
                        optionValue="value"
                        (onChange)="filtraProntofibra($event)"
                        placeholder="Regione"
                        [showClear]="false"
                        [filter]="false"
                        [showHeader]="false"
                        [(ngModel)]="filtroprontofibra.regione"
                      /> -->
                      <button *ngIf="filterIsSet || filterTabellaIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
                        style="background-color: #809cd4; border-color:#191a1b; color: #f9f9f9;font-size: 13px;" (click)="removeFilter()"
                        pTooltip="Rimuovi filtro" tooltipPosition="top" 
                      ></button>
                    </div>
                    <div class="flex justify-end md:justify-center">
                    </div>
                    <div class="flex justify-end md:justify-end">
                        <div class="flex align-items-center" *ngIf="!filterIsSet">
                          <span class=" mr-2 text-900" style="font-size: small;">Mostra attivati</span>
                          <p-inputSwitch [(ngModel)]="mostraprontofibraCompletate" (ngModelChange)="onMostraAttivatiChange($event)"></p-inputSwitch>
                        </div>
                      </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">Azioni</th>
                   
                    <th pSortableColumn="cui" style="font-size: 10px; width: 15%;">
                        CUI
                    </th>
                    <th *ngIf="!isImpresa" class="text-center font-['Poppins']" style="font-size: 10px;width: 7%;">
                      IMPRESA
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      BANDO
                  </th>
                  <th class="text-center font-['Poppins']" style="font-size: 10px; width: 2%;">
                      LOTTO
                  </th>
                   <!--  <th  pSortableColumn="denominazione" style="font-size: 10px; width: 17%;">
                      SCUOLA
                    </th> -->
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      TIPO
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                    REGIONE
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 8%;">
                    COMUNE
                   </th>
                   <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%">
                    STATO PF
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 9px; width: 5%">
                      CATEGORIA VINCOLO
                      </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;">
                      STATO FASE 1
                   </th>
                  <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;;">
                      STATO FASE 2
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;;">
                      PEC ODE
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 3%;;">
                      Comunic.
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;;">
                      Sollecito
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;;">
                      Router installato
                    </th>
                    <th class="text-center font-['Poppins']" style="font-size: 10px; width: 5%;;">
                      Conferma da TS
                    </th>
                  
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row>
                    <tr>
                      <td class="text-center" style="width: 10px;">
                        <button 
                          pButton type="button" style="color:rgb(39, 128, 15)"
                          icon="pi pi-ellipsis-v" class="p-button-rounded p-button-text" 
                          (click)="openCaricaAzioni($event,row)">
                        </button> 
                      </td>
                      <td > 
                        <span class="text-uppercase font-semibold font-['Poppins']" style="font-weight: 300; font-size: 10px; "
                        [pTooltip]="row.denominazione"  tooltipPosition="top"
                        tooltipPosition="top">{{row.cui}}</span> 
                      </td>
                      <td *ngIf="!isImpresa" class="text-center font-['Poppins']"> 
                        <p-tag
                                [value]="row.azienda | uppercase"
                                [style]="{
                                  'background-color': '#326F6F' ,
                                  'color': '#ffffff' ,
                                  'border-radius': '6px',
                                  'padding': '.25em .5rem',
                                  'font-weight': '700',
                                  'font-size': '8px',
                                  'letter-spacing': '.3px;',
                                  'cursor': 'pointer',
                                }"
                                 (click)="filtraPerAzienda(row.azienda)"
                                 [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per azienda '+ row.azienda"
                                  tooltipPosition="top"
                            ></p-tag>
                       </td>
                      <td class="text-center font-['Poppins']">   
                        <p-tag
                              [value]="row.bando | uppercase"
                              [style]="{
                                'background-color': row.bando==='BANDO 1'?'cadetblue':'cornflowerblue' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '8px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                              (click)="filtraPerBando(row.bando)"
                              [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per bando '+ row.bando"
                              tooltipPosition="top"
                              
                          ></p-tag>
                       </td>
                      
                       <td class="text-center font-['Poppins']"> 
                        <p-tag [value]="row.lotto | uppercase"
                              [style]="{
                                'background-color': '#EBC66B' ,
                                'color': '#ffffff' ,
                                'border-radius': '6px',
                                'padding': '.25em .5rem',
                                'font-weight': '700',
                                'font-size': '9px',
                                'letter-spacing': '.3px;',
                                'cursor': 'pointer',
                              }"
                                  class="mr-1"
                                  (click)="filtraPerLotto(row.lotto)"
                                  [pTooltip]="filterIsSet?'ELimina filtro':'Filtra per lotto '+row.lotto"
                                  tooltipPosition="top"
                        ></p-tag>
                      </td>
                      <td *ngIf="row.tipoSede === row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 9px;">{{getTipoSedeAbbreviata(row)}}</span> </td>
                      <td *ngIf="row.tipoSede !== row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase" style="font-weight: bold; font-size: 9px;">{{getTipoSedeAbbreviata(row)}} ({{getTipoSedeEffettivaAbbreviata(row)}})</span> </td>
 
                    <!--   <td *ngIf="row.tipoSede === row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase font-semibold" style="font-weight: 300; font-size: 10px;">{{row.tipoSede}}</span> </td>
                      <td *ngIf="row.tipoSede !== row.tipoSedeEffettiva" class="text-center"> <span class="text-uppercase font-semibold" style="font-weight: 300; font-size: 10px;">{{row.tipoSede}} ({{row.tipoSedeEffettiva}})</span> </td>
                     -->  <td class="text-center font-['Poppins']"> 
                        <span class="text-uppercase font-['Poppins']" style="font-weight: 300;font-size: 10px; "
                        tooltipPosition="top">{{row.regione}}</span> 
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <span class="text-uppercase font-['Poppins']" style="font-weight: 300;font-size: 10px; "
                        [pTooltip]="row.comune"
                        tooltipPosition="top">{{row.comune}}</span> 
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <span 
                          class="material-symbols-outlined stato-icon"
                          [ngClass]="stiliService.getStatoPFIcon(row.codiceStatoProntofibra)"
                          [ngStyle]="{ 'color': stiliService.getStatoPFColor(row.codiceStatoProntofibra) }"
                          [pTooltip]="row.codiceStatoProntofibra" tooltipPosition="top">
                          {{ stiliService.getStatoPFIcon(row.codiceStatoProntofibra) }}
                        </span>
                       <!--  <p-tag
                          [value]="row.codiceStatoProntofibra | uppercase"
                          [style]="{
                            'background-color': stiliService.getStatoPFColor(row.codiceStatoProntofibra) ,
                            'color': '#000000' ,
                            'border-radius': '6px',
                            'padding': '.25em .5rem',
                            'font-weight': '700',
                            'font-size': '10px',
                            'letter-spacing': '.3px;',
                          }"
                        >
                        </p-tag> -->
                      </td>
                      <td class="text-center font-['Poppins']"> 
                       
                        <p-tag *ngIf="row.codiceStatoProntofibra==='KO' && row.categoriaKO"
                          [value]="getCategoriaKOAbbreviata(row) | uppercase"
                          [style]="{
                            'background-color': stiliService.getCategoriaKOPFColor(row.categoriaKO) ,
                            'color': '#FFFFFF' ,
                            'border-radius': '6px',
                            'padding': '.25em .5rem',
                            'font-weight': '700',
                            'font-size': '7.5px',
                            'letter-spacing': '.1px;',
                            'cursor': 'pointer'
                          }"
                           [pTooltip]="row.categoriaLabelKO"
                           tooltipPosition="top"
                        >
                        </p-tag> 
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <p-tag
                          [value]="row.codiceStatoInfratelFase1 | uppercase"
                          [style]="{
                            'background-color': stiliService.getStatoInfratelColor(row.codiceStatoInfratelFase1) ,
                            'color': '#000000' ,
                            'border-radius': '6px',
                            'padding': '.25em .5rem',
                            'font-weight': '700',
                            'font-size': '10px',
                            'letter-spacing': '.3px;',
                          }"
                          ></p-tag>
                        </td>
                      
                      <td class="text-center font-['Poppins']"> 
                        <p-tag
                          [value]="row.codiceStatoInfratelFase2 | uppercase"
                          [style]="{
                            'background-color': stiliService.getStatoInfratelColor(row.codiceStatoInfratelFase2) ,
                            'color': '#000000' ,
                            'border-radius': '6px',
                            'padding': '.25em .5rem',
                            'font-weight': '700',
                            'font-size': '10px',
                            'letter-spacing': '.3px;',
                          }"
                        >
                        </p-tag>
                      </td>
                      <td class="text-center font-['Poppins']"> 
                        <span style="font-weight: 600;font-size: 9px; "
                        tooltipPosition="top">{{utilService.formattaDataDaTimestampFirestore(row.dataPecOde)}}</span> 
                     </td>
                      <td class="text-center font-['Poppins']"> 
                          <span style="font-weight: 500;font-size: 9px; "
                          tooltipPosition="top">{{utilService.formattaDataDaTimestampFirestore(row.dataComunicazioneProntofibra)}}</span> 
                       </td>
                      <td class="text-center font-['Poppins']"> 
                        <ng-container *ngIf="row.sollecitata">
                          <i class="material-symbols-outlined text-orange-700" tooltipPosition="top" [pTooltip]="getSollecitoTooltip(row)" >e911_emergency</i>
                        </ng-container>
                        
                      </td>
                      <td class="text-center font-['Poppins']">
                        <ng-container *ngIf="row.routerInstallato">
                          <i class="material-icons text-green-600" tooltipPosition="top" [pTooltip]="getDataInstallazioneRouterTooltip(row)">router</i>
                        </ng-container>
                        <span *ngIf="row.codiceStatoProntofibra==='KO' && !row.routerInstallato"
                          class="material-symbols-outlined small-icon"
                          [ngStyle]="{ 'color': '#D85835' }"
                          [pTooltip]="getDataMancataInstallazioneRouterTooltip(row)" tooltipPosition="top">
                          {{ 'error' }}
                        </span>
                      </td>
                      
                      <td class="text-center font-['Poppins']"> 
                        <ng-container *ngIf="row.attivazioneConfermataDaTS">
                          <i class="material-icons text-green-900" tooltipPosition="top" [pTooltip]="getDataConfermaAttivazioneTooltip(row)" >check</i>
                        </ng-container>
                      </td>
                     
                      </tr>
                </ng-template>
              </p-table> 
              <p-tieredMenu #menuAzioniTiered [popup]="true" [model]="menuAzioniItems"></p-tieredMenu>
            </div>
		</div>

    <p-dialog [(visible)]="showSollecitaConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
      <div class="flex flex-column align-items-center my-4">
         <span class="flex align-items-center justify-content-center bg-orange-100 text-orange-800 border-circle mb-3" style="width:64px;height:64px">
             <i class="material-symbols-outlined small-icon" >e911_emergency</i>
         </span>
         <div class="font-medium text-2xl text-900">SOLLECITA PRONTOFIBRA</div>
     </div>
     <p class="line-height-3 p-0 m-0">
        Confermi di voler sollecitare FIBERCOP per la preparazione del prontofibra della pratica <span style="font-weight: bold;">{{selectedProntofibra?selectedProntofibra.cui :''}} </span>?
     </p>
     <ng-template pTemplate="footer">
         <div class=" border-top-1 surface-border pt-3 flex">
             <button pButton pRipple icon="pi pi-times" (click)="showSollecitaConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2" style="background-color: #3d64b3; color: white;"></button>
             <button pButton pRipple icon="pi pi-send" (click)="confermaSollecitaPF()" label="CONFERMA" class="p-button-success w-6 ml-2 bottone-modale" style="border-color: green;"></button>
         </div>
     </ng-template>
    </p-dialog>  

    <p-dialog [(visible)]="showSollecitaMassivamenteConfirmation" appendTo="body" [modal]="true" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" [closable]="false" [showHeader]="false">
      <div class="flex flex-column align-items-center my-4">
         <span class="flex align-items-center justify-content-center border-circle mb-3" style="width:64px;height:64px; background-color: #e8c516; color: #ffffff;">
             <i class="material-symbols-outlined small-icon" >campaign</i>
         </span>
         <div class="font-medium text-2xl text-900">SOLLECITA PRONTOFIBRA IN ATTESA</div>
     </div>
     <p class="line-height-3 p-0 m-0">
        Confermi di voler sollecitare FIBERCOP per TUTTE le <b>{{numeroInAttesa}}</b> pratiche IN ATTESA?
     </p>
     <ng-template pTemplate="footer">
         <div class=" border-top-1 surface-border pt-3 flex">
             <button pButton pRipple icon="pi pi-times" (click)="showSollecitaMassivamenteConfirmation = false" label="ANNULLA" class="p-button-outlined w-6 mr-2" style="background-color: #3d64b3; color: white;"></button>
             <button pButton pRipple icon="pi pi-send" (click)="confermaSollecitaMassivamente()" label="CONFERMA" class="p-button-success w-6 ml-2 bottone-modale" style="border-color: green;"></button>
         </div>
     </ng-template>
    </p-dialog>  
     
    <p-toast position="center"></p-toast>
<!--
<p-confirmDialog></p-confirmDialog> -->